import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { LIGHTNING_LEGEND } from './lightning.legend';
import { LIGHTNING_PRODUCT_DATA } from './lightning.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class LightningGeoJsonPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(LIGHTNING_PRODUCT_DATA, {
    legend: LIGHTNING_LEGEND,
    twcLayerTypes: ['geojson']
  });
}
